import { apiFetch } from "./client";

/**
 * AI-1 — AI-помічник CRM (D-105). Клієнт викликає ВИКЛЮЧНО CRM-проксі
 * (/Custom/frontend/assistant/*); 0 прямих ai.* з браузера (TZ §1, grep-AC).
 * roleTier/accessMode НЕ надсилаються — проксі виводить їх server-side.
 */

export type AssistantState =
  | "ok"
  | "no_coverage"
  | "pii_warning"
  | "rate_limited"
  | "unavailable";

export interface AssistantSource {
  kbDocId: string;
  title: string;
  section: string;
  indexVersion: string;
}

export interface AssistantAnswer {
  state: AssistantState;
  answer: string;
  sources: AssistantSource[];
  indexVersion: string;
  /** AC-AI-SRC-DATE: ISO-дата білда поточного індексу; "" → graceful (без дати). */
  indexedAt: string;
  piiDetected: string[];
  uiHint?: string | null;
  requestId: string;
  /** server-derived — для бейджа «модуль · роль» + Director-RO copy. */
  roleTier: string;
  accessMode: "admin" | "readOnly" | "actionAllowed" | string;
  roleLabel: string;
  moduleLabel?: string | null;
  retryAfter?: number;
}

/** whitelist-контекст, який клієнт МОЖЕ надіслати (проксі валідує + дропає інше). */
export interface AssistantClientCtx {
  routeKey?: string;
}

export function askAssistant(
  question: string,
  ctx: AssistantClientCtx = {},
  signal?: AbortSignal,
): Promise<AssistantAnswer> {
  return apiFetch<AssistantAnswer>("/Custom/frontend/assistant/ask", {
    method: "POST",
    body: { question, ctx },
    signal,
  });
}

export type FeedbackVote = "up" | "down";
export type FeedbackReason = "incorrect" | "outdated" | "no_source" | "unclear";

export interface FeedbackPayload {
  requestId: string;
  vote: FeedbackVote;
  reasons?: FeedbackReason[];
  comment?: string;
}

export interface FeedbackResult {
  ok: boolean;
  delivered: boolean;
}

export function sendFeedback(payload: FeedbackPayload): Promise<FeedbackResult> {
  return apiFetch<FeedbackResult>("/Custom/frontend/assistant/feedback", {
    method: "POST",
    body: payload,
  });
}

/** UI-fallback, коли навіть проксі недосяжний (мережа/throw) — питання не губиться. */
export function unavailableResult(): AssistantAnswer {
  return {
    state: "unavailable",
    answer: "",
    sources: [],
    indexVersion: "",
    indexedAt: "",
    piiDetected: [],
    requestId: "",
    roleTier: "",
    accessMode: "",
    roleLabel: "",
    moduleLabel: null,
  };
}
